import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import AddUserButton from './AddUserButton';
import EditUserInputs from '../../inputs/EditUserInputs';
import SearchUser from './SearchUser';
import ShowUsers from './ShowUsers';
import NotificationSettings from './NotificationSettings';
import DefaultProfiles from './DefaultProfiles';
import UserSingle from './UserSingle';
import FlashMessageList from '../../inputs/FlashMessageList';
import './users.scss'

class PageUsers extends PureComponent {
	constructor(props) {
		super(props);

		this.state = {};
	}

	render() {
		return (
			<div className="sidebar-offcanvas mobile-space-left-2 mobile-pad-left-2 usersPageContainer">

				<div className="usersPageContent">
					<div>
						<FlashMessageList {...this.props} />
					</div>
					<div className="userPageHeader">
						<SearchUser {...this.props} />
						{' '}
						<AddUserButton {...this.props} />
					</div>

					<div>
						{(() => {
							switch (this.props.users_tab) {
							case 'users':
								return <ShowUsers {...this.props} />;

							case 'default-profiles':
								return <DefaultProfiles {...this.props} />;

							case 'user-single':
								return <UserSingle {...this.props} />;

							default:
								return <ShowUsers {...this.props} />;
							}
						})()}

					</div>
				</div>

			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		all_users: state.settings_users.all_users,
		searched_users: state.settings_users.searched_users,
		user_filter: state.settings_users.user_filter,
		users_tab: state.settings_users.users_tab,
	};
}

export default connect(mapStateToProps)(PageUsers);
